import { useEffect } from 'react';
import { Icon } from '../../components/Icon';

export function LearningPreviewModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!open) return;
    const closeOnEscape = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose(); };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [onClose, open]);

  if (!open) return null;

  return <div className="learning-preview-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className="learning-preview" role="dialog" aria-modal="true" aria-labelledby="learning-preview-title">
      <header>
        <div className="learning-preview-mark"><Icon name="book" /></div>
        <div><small>CAIGEN · LEARNING ROOTS</small><h2 id="learning-preview-title">学习，在这里慢慢扎根</h2><p>Wordess 与后续学习工具会共用菜根账户、节律和成长数据。</p></div>
        <button type="button" aria-label="关闭学习预告" onClick={onClose}><Icon name="close" /></button>
      </header>
      <div className="learning-preview-status"><b>敬请期待</b><span>这里是菜根内的学习入口预告，当前不会跳转到 Wordess。</span></div>
      <div className="learning-preview-grid">
        <article><i>词</i><div><small>WORDESS</small><h3>词汇与复习</h3><p>把生词、语境与间隔复习汇成一条可持续的学习路径。</p></div><span>打磨中</span></article>
        <article><i>习</i><div><small>RHYTHM</small><h3>今日学习</h3><p>从日程和薄弱项生成当天可以真正完成的学习节律。</p></div><span>规划中</span></article>
        <article><i>析</i><div><small>INSIGHT</small><h3>成长分析</h3><p>让复习记录进入成长画像，但由你决定哪些数据参与分析。</p></div><span>待接入</span></article>
      </div>
      <footer><p><b>为什么暂时不直接跳转？</b><span>Wordess 仍在统一视觉和账户体验；完成打磨前，菜根不会把你带进一个难以返回的半成品页面。</span></p><button type="button" onClick={onClose}>暂不跳转 · 留在菜根</button></footer>
    </section>
  </div>;
}
